'use strict';

var _ = require('lodash');
// var NavConstants = require('../NavConstants');

function NavLeftController ($scope, $rootScope, Flux, Utils, MapActions, NavActions, IdentityService) {

  var vm = this;
  var NavStore = Flux.Store.get('NavStore');
  var AnnotationStore = Flux.Store.get('AnnotationStore');
  var MeasurementStore = Flux.Store.get('MeasurementStore');

  vm.isBetaUser = IdentityService.isBetaUser();

  _.defaults(this, {
    currentPage: '',
    currentPageView: '',
    openDrawer: false
  });

  /*
   * Drawer control variables.
   * It is better to explicitely name the pages and views supported by the drawer,
   * instead of assuming they are orthogonal (i.e. each having a 'list', 'edit',
   * etc.) for supporting arbitrary views and making the intention unambiguous
   * when changing page
   */
  var _availableViews = {
    annotations: [
      'annotations-list',
      'annotations-edit'
    ],
    overlays: [
      'overlays-list',
      'overlays-edit'
    ],
    measurements: [
      'measurements-list',
      'measurements-edit'
    ]
  };

  var _defaultViews = {
    annotations: 'annotations-list',
    measurements: 'measurements-list',
    overlays: 'overlays-list'
  };

  /**
   * This function toggles the drawer on the left.
   * If the drawer is open: it will close it, and will not change the current
   * page or view.
   * If the drawer is closed: it will open it. If a viewId is passed, it will
   * replace the current view. If it is not passed, and there is no current view
   * or the current view does not correspond to the current page, it will load
   * the default view as specified by the _defaultViews variable
   * @param  {String} pageId
   */
  vm.toggleDrawer = function (pageId, viewId) {
    if (!pageId) {
      console.error('pageId required');
      return;
    }
    if (vm.isDisabled()) {
      NavActions.ChangeDrawerWhileDisabled.dispatch(viewId);
      return;
    }
    // From close to open, or change the current page
    if (!vm.openDrawer || pageId !== vm.currentPage) {
      var _view = viewId || vm.currentPageView;
      if (!_view || !_.includes(_availableViews[vm.currentPage], _view)) {
        _view = _defaultViews[pageId];
      }
      NavActions.OpenDrawer.dispatch(pageId, viewId);
    } else if (vm.openDrawer && pageId === vm.currentPage) {
      NavActions.CloseDrawer.dispatch();
    }
  };

  ////////////////

  vm.isDisabled = function() {
    if (!vm.openDrawer) {
      return false;
    }
    var page = vm.currentPage;
    if (page === 'annotations') {
      return vm.currentPageView === 'annotations-edit';
    } else if (page === 'overlays') {
      return vm.currentPageView === 'overlays-edit';
    } else if (page === 'measurements') {
      return vm.currentPageView === 'measurements-edit';
    }
    return false;
  };

  vm.isActive = function(page) {
    return vm.openDrawer && vm.currentPage === page;
  };

  vm.afterDrawerOpen = function () {
    MapActions.ResizeMap.dispatch();
  };

  vm.afterDrawerClose = function () {
    MapActions.ResizeMap.dispatch();
  };

  vm.whileDrawerAnimating = function () {
    MapActions.ResizeMap.dispatch();
  };

  //////////////////////////////////////////////////////////////////////////////
  // Controller Actions
  //////////////////////////////////////////////////////////////////////////////

  /*
   * Close the drawer. If options.prompt is set, it will broadcast a message with
   * the specified value to the rootscope instead, to trigger a confirmation
   * dialog
   */
  vm.closeDrawer = function(options) {
    console.log('close the drawer');
    options = options || {};

    if (options.prompt) {
      $rootScope.$broadcast(options.prompt);
    } else {
      // Restore to defaults
      NavActions.CloseDrawer.dispatch();
    }
  };

  //////////////////////////////////////////////////////////////////////////////
  // Store Event Handlers
  // NOTE: $scope should ALWAYS be passed to prevent memory leaks
  //////////////////////////////////////////////////////////////////////////////

  // This shouldn't watch the page changes and notify. Flux model requires the
  // properties of this controller to always be passed by the store, watched by
  // the onNavStoreChanged event handler

  var onNavStoreChanged = function () {
    vm.currentPage = NavStore.get('drawerPage');
    vm.currentPageView = NavStore.get('drawerView');
    vm.openDrawer = NavStore.get('drawerOpen');
  };

  NavStore.on(NavStore.Events.Changed, onNavStoreChanged, $scope);
}

NavLeftController.$inject = ['$scope', '$rootScope', 'sbFlux', 'Utils', 'MapActions', 'NavActions', 'IdentityService'];
module.exports = NavLeftController;



// WEBPACK FOOTER //
// ./src/app/dash/nav/navLeft/NavLeftController.js